export const SERVICE_CODE = 'ACTIVITIES' + '_SERVICE';
